import {styled} from "@mui/styles";

export const ItemsContainer = styled("div")(({isMobile}: { isMobile?: boolean }) => ({
    height: "fit-content",
    width: "100%",
    display: "grid",
    gridTemplateColumns: isMobile ? "auto auto" : "auto auto auto auto",
    gap: "15px",
    padding: "10px",
    marginTop: "10px",
}));
